import { gql } from "graphql-tag";

export const deletePromptAnswer = gql`
  mutation DeletePromptAnswer($id: Int!) {
    promptAnswer: delete_prompt_answer(id: $id) {
      id
      promptId: prompt_id
      userId: user_id
      bookId: book_id
      promptBook: prompt_book {
        promptId: prompt_id
        bookId: book_id
        answersCount: answers_count
      }
    }
  }
`;
